import { render, staticRenderFns } from "./finance-syrz-list.vue?vue&type=template&id=72f9f50e&scoped=true&"
import script from "./finance-syrz-list.vue?vue&type=script&lang=js&"
export * from "./finance-syrz-list.vue?vue&type=script&lang=js&"
import style0 from "./finance-syrz-list.vue?vue&type=style&index=0&id=72f9f50e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9f50e",
  null
  
)

export default component.exports